import { CampaignAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { AUCTION_TYPES, IAuction, IAuctionRepository } from "./model"

export const auctionRPO: IAuctionRepository = {
  getAuctions(campaignId: number): Promise<IAuction[]> {
    return new Promise<IAuction[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.getApiCampaignAuctionTypeList(campaignId)
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting all campaign auctions", error)
            reject("auction.get.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting auction", ex)
        reject("auction.get.error.unexpected")
      }
    })
  },
  addAuction(campaignId: number, auctionType: AUCTION_TYPES): Promise<IAuction> {
    return new Promise<IAuction>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.postApiCampaignAuctionType({ campaign_id: campaignId, auction_type_id: auctionType as any })
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while adding auction", error)
            reject("auction.add.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while adding auction", ex)
        reject("auction.add.error.unexpected")
      }
    })
  },
  deleteAuction(campaignId: number, auction: IAuction): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.deleteApiCampaignAuctionType(campaignId, auction.id)
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while deleting auction", error)
            reject("auction.delete.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while deleting auction", ex)
        reject("auction.delete.error.unexpected")
      }
    })
  }
}
